import { Alert } from '@mui/material';
import { useColors } from '../context/ThemeContext';

export default function AuthAlert({ children, ...props }) {
  const colors = useColors();
  return (
    <Alert
      severity="error"
      role="alert"
      sx={{ bgcolor: colors.errorBg, color: colors.error, border: `1px solid ${colors.error}40` }}
      {...props}
    >
      {children}
    </Alert>
  );
}
